/** @format */

import DashboardContentBox from "../DashboardContentBox";

import styles from "../../../styles/Components/new-dashboard/bot-performance/BotItem.module.css";
import React, { useState } from "react";
import BotDetailModal from "./BotDetailModal";
import { Button, message, Modal, Tooltip } from "antd";
import useServiceStatus from "../../../hooks/useServiceStatus";
import { RiLockFill } from "react-icons/ri";
import alert from "../../alerts/Alert";
import {
  checkBotStatus,
  deactivateBot,
  getBotPerformanceReportPdf,
} from "../../../redux/bot/actions";
import DisplayBotStatus from "../../../shared/bot-activation-process/DisplayBotStatus";
import { useDispatch, useSelector } from "react-redux";
import ActivateBotServiceModal from "../../bot/ActivateBotServiceModal";
import moment from "moment";
import BotIcon from "../../../ui/icons/BotIcon";
import { PiChartLineUpBold } from "react-icons/pi";
import useUserData from "../../../hooks/useUserData";
import PerformanceReportModal from "../../bot/bot-reports/PerformanceReportModal";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";

function BotItem({ type = "botInfo", data = {}, children, onClick }) {
  const {
    main: { userData },
    botState: {
      activateBotLoading,
      deactivateBotLoading,
      performanceReports,
      performanceReportsStatus,
    },
  } = useSelector((state) => state);
  const {
    bot_name: name,
    profit_percent: profit,
    status,
    exchange_id,
    bot_creation_id: botId,
    win_rate: winRate,
  } = data;

  const { isActive: isBotServiceActive } = useServiceStatus("bot");

  const isBotActive = status === "Active";

  const [showModal, setShowModal] = useState(false);
  const [showBotActivationModal, setShowBotActivationModal] = useState(false);
  const [showServiceActivationModal, setShowServiceActivationModal] =
    useState(false);
  const [selectedBotId, setSelectedBotId] = useState(null);
  const [showPerformanceReportModal, setShowPerformanceReportModal] =
    useState(false);
  const [showFullName, setShowFullName] = useState(false);

  const botProcessLoading =
    (activateBotLoading || deactivateBotLoading) && selectedBotId === botId;

  const isBotNew = botId ? moment().diff(moment(botId), "day") <= 1 : false;

  const dispatch = useDispatch();

  const { username, email } = useUserData();

  const performanceReportStatus = performanceReportsStatus?.[botId];
  const performanceReport = performanceReports?.[botId];

  const handleBotActivity = () => {
    if (!status) return message.info("Choose the bot first!");
    if (!isBotServiceActive) {
      setShowServiceActivationModal(true);
      return;
    }

    setSelectedBotId(botId);

    const isActivating = status === "Inactive";
    const actionText = isActivating ? "activate" : "deactivate";

    Modal.confirm({
      title: `Confirm ${actionText}`,
      content: `Are you sure you want to ${actionText} this bot?`,
      okText: "Yes",
      cancelText: "No",
      centered: true,
      onOk: () => {
        setSelectedBotId(botId);

        if (isActivating) {
          if (exchange_id === "None") {
            return alert(
              "",
              "You cannot activate this bot because it is not integrated with any exchange.",
              "info",
              {
                cancel: "Ok",
              },
            );
          }

          dispatch(
            checkBotStatus(
              userData?.["custom:custom_username"],
              userData?.["cognito:username"],
              botId,
              exchange_id,
            ),
          );
          setShowBotActivationModal(true);
        } else {
          dispatch(
            deactivateBot(
              userData?.["custom:custom_username"],
              userData?.["cognito:username"],
              botId,
            ),
          );
        }
      },
    });
  };

  const showMore = () => {
    if (!isBotServiceActive) {
      setShowServiceActivationModal(true);
      return;
    }

    if (
      !performanceReport?.pdf_url &&
      performanceReportStatus !== "loading" &&
      performanceReportStatus !== "success"
    ) {
      dispatch(getBotPerformanceReportPdf(username, email, botId));
    }
    setShowPerformanceReportModal(true);
  };

  const clickHandler = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <DashboardContentBox
        style={{
          borderStyle: `${type === "botInfo" ? "solid" : "dashed"}`,
          borderColor: "#b0d0ff",
          cursor: `${type === "botInfo" ? "unset" : "pointer"}`,
        }}
        className={`${styles.box} ${type !== "botInfo" ? styles.addBot : ""}`}
        onClick={clickHandler}
      >
        {type === "botInfo" ? (
          <>
            {isBotNew && <div className={styles.newBadge}>New</div>}
            <div className={styles.header}>
              <div className={styles.leftHeader}>
                <div className={styles.botIcon}>
                  <BotIcon />
                </div>
                {/*<Tooltip*/}
                {/*  title={name}*/}
                {/*  placement="top"*/}
                {/*  color="#0c4cfc"*/}
                {/*  mouseEnterDelay={0.5}*/}
                {/*>*/}
                {/*  <h6 className={styles.botName}>{name}</h6>*/}
                {/*</Tooltip>*/}
              </div>
              <div className={styles.rightHeader}>
                <span
                  className={`${styles.status} ${isBotActive ? styles.activeStatus : styles.inactiveStatus}`}
                >
                  {status}
                </span>

                <div className={styles.logoContainer}>
                  <img
                    src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${exchange_id}.svg`}
                    alt={exchange_id}
                    className={styles.exchangeLogo}
                  />
                </div>
              </div>
            </div>

            <Tooltip
              title={name}
              placement="bottom"
              color="#0c4cfc"
              open={showFullName}
            >
              <h6
                className={styles.botName}
                onMouseEnter={() => setShowFullName(true)}
                onMouseLeave={() => setShowFullName(false)}
              >
                {name}
              </h6>
            </Tooltip>

            <div className={styles.botInfo}>
              <PiChartLineUpBold color="rgb(13, 74, 249)" />
              Profit:{" "}
              <span className={profit !== "N/A" ? styles.profit : ""}>
                {profit} {profit !== "N/A" ? "%" : ""}
              </span>
            </div>

            <div className={styles.botInfo}>
              <PiChartLineUpBold color="rgb(13, 74, 249)" />
              Win Rate:{" "}
              <span className={winRate !== "N/A" ? styles.profit : ""}>
                {winRate}
                {/*{winRate !== "N/A" ? "%" : ""}*/}
              </span>
            </div>
          </>
        ) : (
          <>{children}</>
        )}
        {type === "botInfo" && (
          <div className={styles.handlers}>
            <Button
              className={`${styles.actionBtn} ${styles.activationBtn}`}
              loading={Boolean(botProcessLoading)}
              disabled={Boolean(botProcessLoading)}
              onClick={handleBotActivity}
            >
              {!isBotServiceActive && <RiLockFill size={12} />}
              {status === "Active" ? "Deactivate" : "Activate"}?
            </Button>
            <div className={styles.detailsBtn} onClick={showMore}>
              Performance
              <HiOutlineClipboardDocumentList size={14} />
            </div>
          </div>
        )}
      </DashboardContentBox>

      {showModal && (
        <BotDetailModal
          setShow={setShowModal}
          visible={showModal}
          data={data}
        />
      )}

      <DisplayBotStatus
        show={showBotActivationModal}
        onClose={setShowBotActivationModal}
        botId={botId}
        exchangeId={exchange_id}
      />
      {showServiceActivationModal && (
        <ActivateBotServiceModal
          setShowActivationModal={setShowServiceActivationModal}
          showActivationModal={showServiceActivationModal}
        />
      )}

      {showPerformanceReportModal && (
        <PerformanceReportModal
          open={showPerformanceReportModal}
          close={() => setShowPerformanceReportModal(false)}
          bot={botId}
          botInfo={data}
        />
      )}
    </>
  );
}

export default BotItem;
